import {
	schoolSubject
} from './standard.js';
import API from "../api.js"

export const subjectList = JSON.parse(localStorage.getItem('subjectList')) || []
export async function getClassByGradeId(gradeId) {
	try {
		const res = await API.get(API.school.getSchoolGradClass, {
			schoolId: localStorage.getItem('orgId'),
			gradeId: gradeId
		})
		let list = res.data.data || []

		var stag = gradeId < 7 ? 1 : gradeId < 10 ? 2 : 3
		let subject = subjectList?.filter(v => v.stageCode == stag)?.filter(v => v.value > 0)?.map(item => ({
			...item,
			isRole: false
		}))
		return list.map(item => ({
			...item,
			value: item.id,
			label: `${item.classAlias}(${item.areaName||"主校区"})`,
			isRole: false,
			subjectList: [{
				value: 0,
				label: '全部学科',
				isRole: false
			}, ...subject]
		}))
	} catch (e) {
		return []
	}
}
export async function getSchoolGradClassList(year) {
	try {
		
		const res = await API.get(API.school.getSchoolGradClassList, {
			schoolId: localStorage.getItem('orgId'),
			year: year
		})
		
		let gradeList=[]
		if (res.data.code == 200) {
			gradeList = res?.data?.data.map(v => {
				var sectionId = v.grade < 7 ? 1 : v.grade < 10 ? 2 : v.grade < 13 ? 3 : 0
				let subject = subjectList?.filter(t => t.stageCode == sectionId)?.filter(t => t.value > 0)
					?.map(item => ({
						...item,
						isRole: false
					}))
				let classList = v.classList.map(_v => {
					return {
						..._v,
						value: _v.id,
						label: `${_v.classAlias}(${_v.areaName||"主校区"})`,
						isRole: false,
						subjectList: [{
							value: 0,
							label: '全部学科',
							isRole: false
						}, ...subject]
					}
				})
				v.classList = [{
						id: 0,
						value: 0,
						label: "全部班级",
						isRole: false,
						subjectList: [{
							value: 0,
							label: '全部学科',
							isRole: false
						}, ...subject?.filter(t => t.stageCode == sectionId)]
					},
					...classList
				]


				return {
					...v,
					sectionId: sectionId,
					isRole: false,
					gradeId: v.grade,
					gradeName: v.gradeName,
					value: v.grade,
					label: v.gradeName,
					isRole: false,
				}
			})
		}
		
		let result = [{
			gradeId: 0,
			gradeName: '全部年级',
			value: 0,
			label: "全部年级",
			isRole: true,
			classList: [{
				id: 0,
				classId: 0,
				value: 0,
				label: "全部班级",
				classAlias: "全部班级",
				isRole: true,
				subjectList: [{
					value: 0,
					label: '全部学科',
					isRole: true
				}]
			}]
		}, ...gradeList]?.sort((a,b)=>a.value-b.value)
		
		return result
	} catch (e) {
		return []
	}
}
// 工具：获取所有年级 + 对应班级（超管用）
export async function getAllGradeAndClass() {
	try {
		const res = await API.get(API.school.getSchoolGrad, {
			schoolId: localStorage.getItem('orgId')
		})
		let gradeList = res.data.data || []
		if (gradeList.length > 0) {
			gradeList = gradeList.map(v => {
				var sectionId = v.grade < 7 ? 1 : v.grade < 10 ? 2 : v.grade < 13 ? 3 : 0
				return {
					...v,
					sectionId: sectionId,
					isRole: false
				}
			})
		}

		const result = []
		let subject = subjectList?.filter(v => v.value > 0)?.map(item => ({
			...item,
			isRole: false
		}))
		for (let i = 0; i < gradeList.length; i++) {
			var sectionId = gradeList[i].grade < 7 ? 1 : gradeList[i].grade < 10 ? 2 : gradeList[i].grade < 13 ?
				3 :
				0
			const grade = gradeList[i]
			const classArr = await getClassByGradeId(grade.grade)
			if (classArr.length > 0) {
				result.push({
					gradeId: grade.grade,
					gradeName: grade.gradeName,
					value: grade.grade,
					label: grade.gradeName,
					isRole: false,
					classList: [{
						id: 0,
						value: 0,
						label: "全部班级",
						isRole: false,
						subjectList: [{
							value: 0,
							label: '全部学科',
							isRole: false
						}, ...subject?.filter(v => v.stageCode == sectionId)]
					}, ...classArr]
				})
			}
		}

		return result
	} catch (e) {
		return []
	}
}

// 最终导出：根据用户角色自动获取可访问班级
export async function getUserClassList(year) {
	const roleType = localStorage.getItem('roleType')
	let resultt = []
	let yearRole = []
	try {
		if (!year) {
			let semester = localStorage.getItem("semester")
			if (semester) {
				let arr = JSON.parse(semester) || []
				if (arr) {
					var yeart = arr.find(v => v.status == 1)?.year || null
					if (yeart) {
						year = yeart
					}
				}
			}
		}
		// ==========【修复缓存判断】==========
		const cacheStr = localStorage.getItem("roleClassList");
		if (cacheStr) {
			yearRole = JSON.parse(cacheStr) || []
			if (year && Array.isArray(yearRole)) {
				// 精准匹配当前学年
				const targetYearItem = yearRole.find(v => v.year === year);
				if (targetYearItem) {
					// 命中缓存，直接返回
					return targetYearItem.roleClassList || [];
				}
			}
		}
		// 缓存未命中，请求接口
		if (roleType === '1') {
			// let listOne = await getAllGradeAndClass()
			let listOne = await getSchoolGradClassList(year)
			// listOne = [{
			// 		gradeId: 0,
			// 		gradeName: '全部年级',
			// 		value: 0,
			// 		label: "全部年级",
			// 		isRole: true,
			// 		classList: [{
			// 			id: 0,
			// 			classId: 0,
			// 			value: 0,
			// 			label: "全部班级",
			// 			classAlias: "全部班级",
			// 			isRole: true,
			// 			subjectList: [{
			// 				value: 0,
			// 				label: '全部学科',
			// 				isRole: true
			// 			}]
			// 		}]
			// 	},
			// 	...listOne
			// ]
			resultt = classIs(listOne, 1) || []
		} else {
			const userInfoStr = localStorage.getItem('userInfo')
			if (!userInfoStr) {
				resultt = []
			} else {
				const userInfo = JSON.parse(userInfoStr)
				// const classes = await getAllGradeAndClass()
				let classes = await getSchoolGradClassList(year)
				if (roleType == '0') {
					resultt = classIs(classes, 2, userInfo) || []
				} else {
					// 其他角色兜底，防止resultt为空
					resultt = []
				}
			}
		}
	} catch (e) {
		console.error("getUserClassList异常：", e);
		resultt = []
	} finally {
		// =========【修复：find前判空】========
		let list = []
		if (Array.isArray(yearRole)) {
			const targetYearItem = yearRole.find(v => v.year === year);
			if (targetYearItem) {
				targetYearItem.roleClassList = resultt
				list = yearRole
			} else {
				list = [{
					year: year,
					roleClassList: resultt
				}, ...yearRole]
			}
		} else {
			list = [{
				year: year,
				roleClassList: resultt
			}]
		}
		localStorage.setItem("roleClassList", JSON.stringify(list))
		return resultt
	}
}
export function classIs(list, type, role) {

	let gradeList = []
	if (type == 1) {
		for (let i = 0; i < list.length; i++) {
			list[i].isRole = true
			let classList = list[i].classList
			for (let a = 0; a < classList.length; a++) {
				classList[a].isRole = true
				let subjectList = classList[a].subjectList
				//可以在班级增加所有的年级
				for (let s = 0; s < subjectList.length; s++) {
					subjectList[s].isRole = true
				}
				classList[a].subjectList = subjectList
			}
			list[i].classList = classList
		}
		gradeList = list
	} else {
		let roleList = role
		//先判断子管理2子管理员 3校领导 4部门 5年级组长 6学科组长 7备课组长 8班主任 9副班主任 10普通老师
		if (roleList.filter(v => v.roleType == 2).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 2)[0].assignList
			list = admin(list, adminList)

		}
		//校领导，逻辑同子管理
		if (roleList.filter(v => v.roleType == 3).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 3)[0].assignList
			list = admin(list, adminList)
		}
		//部门，逻辑同子管理
		if (roleList.filter(v => v.roleType == 4).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 4)[0].assignList
			list = admin(list, adminList)
		}
		//年级组长
		if (roleList.filter(v => v.roleType == 5).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 5)[0].assignList
			list = gradeLeader(list, adminList)
		}
		//学科组长
		if (roleList.filter(v => v.roleType == 6).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 6)[0].assignList
			list = subjectLeader(list, adminList)
		}
		//备课组长
		if (roleList.filter(v => v.roleType == 7).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 7)[0].assignList
			list = gradeSubjectLeader(list, adminList)
		}
		//班主任  正常
		if (roleList.filter(v => v.roleType == 8).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 8)[0].assignList
			list = headTeacher(list, adminList)
		}
		//副班主任  正常
		if (roleList.filter(v => v.roleType == 9).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 9)[0].assignList
			list = headTeacher(list, adminList)
		}
		//老师正常
		if (roleList.filter(v => v.roleType == 10).length > 0) {
			var adminList = roleList.filter(v => v.roleType == 10)[0].assignList
			list = teacher(list, adminList)
		}
		gradeList = list
	}

	return gradeList
}
export function teacher(list, roleList) {
	for (let i = 0; i < list.length; i++) {
		if (roleList.filter(v => v.gradeId == list[i].gradeId).length > 0) {
			list[i].isRole = true
			let roleListG = roleList.filter(v => v.gradeId == list[i].gradeId)
			list[i].classList = list[i]?.classList?.map(v => {
				if (roleListG.filter(a => a.classId == v.id).length > 0) {
					v.isRole = true
					v.subjectList = v.subjectList?.map(_v => {
						if (roleListG.filter(a => a.subjectId == _v.subjectId).length > 0) {
							_v.isRole = true
						}
						return {
							..._v
						}
					})
				}
				return {
					...v
				}
			})

		}
	}
	return list
}
export function headTeacher(list, roleList) {
	for (let i = 0; i < list.length; i++) {
		if (roleList.filter(v => v.gradeId == list[i].gradeId).length > 0) {
			list[i].isRole = true
			let roleListG = roleList.filter(v => v.gradeId == list[i].gradeId)
			list[i].classList = list[i]?.classList?.map(v => {
				if (roleListG.filter(a => a.classId == v.id).length > 0) {
					v.isRole = true
					v.subjectList = v.subjectList?.map(_v => {
						_v.isRole = true
						return {
							..._v
						}
					})
				}
				return {
					...v
				}
			})

		}
	}
	return list
}
export function gradeSubjectLeader(list, roleList) {
	for (let i = 0; i < list.length; i++) {

		for (let a = 0; a < roleList.length; a++) {
			var gradeId = roleList[a].gradeId
			if (gradeId == list[i].gradeId) {
				list[i].isRole = true
				if (list[i].classList.length > 0) {
					list[i].classList = list[i].classList.map(v => {

						v.isRole = true
						if (v.subjectList.length > 0) {
							v.subjectList = v.subjectList.map(_v => {
								if (_v.value == roleList[a].subjectId) {
									_v.isRole = true
								}
								return {
									..._v
								}
							})
						}
						return {
							...v
						}
					})
				}
			}
		}
	}
	return list
}
export function subjectLeader(list, roleList) {
	for (let i = 0; i < list.length; i++) {
		for (let a = 0; a < roleList.length; a++) {
			var sectionId = roleList[a].sectionId
			if (sectionId == list[i].sectionId) {
				list[i].isRole = true
				if (list[i].classList.length > 0) {
					list[i].classList = list[i].classList.map(v => {
						v.isRole = true
						if (v.subjectList.length > 0) {
							v.subjectList = v.subjectList.map(_v => {
								if (_v.value == roleList[a].subjectId) {
									_v.isRole = true
								}
								return {
									..._v
								}
							})
						}
						return {
							...v
						}
					})
				}
			}
		}
	}
	return list
}
export function gradeLeader(list, roleList) {
	for (let i = 0; i < list.length; i++) {
		for (let a = 0; a < roleList.length; a++) {
			var gradeId = roleList[a].gradeId
			if (gradeId == list[i].gradeId) {
				list[i].isRole = true
				if (list[i].classList.length > 0) {
					list[i].classList = list[i].classList.map(v => {
						v.isRole = true
						if (v.subjectList.length > 0) {
							v.subjectList = v.subjectList.map(_v => {
								_v.isRole = true
								return {
									..._v
								}
							})
						}
						return {
							...v
						}
					})
				}
			}
		}
	}
	return list
}
export function admin(list, adminList) {
	for (let i = 0; i < list.length; i++) {
		list[i].sectionId = list[i].gradeId < 7 ? 1 : list[i].gradeId < 10 ? 2 : 3
		for (let a = 0; a < adminList.length; a++) {
			var adminNew = adminList[a].sectionId
			//子管理员的方法
			if (list[i].sectionId == adminNew) {
				list[i].isRole = true
				// list[a].isRole=true
				if (list[i].classList.length > 0) {
					list[i].classList = list[i].classList.map(t => {
						t.isRole = true
						if (t.subjectList.length > 0) {
							t.subjectList = t.subjectList.map(_t => {
								_t.isRole = true
								return {
									..._t
								}
							})
						}
						return {
							...t
						}
					})
				}
			}
		}
	}
	return list
}